var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatusehat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 27.7667C134 12.4009 120.007 0.293419 104.022 3.52598C92.5947 5.83699 84.4606 16.522 84.4606 28.5205V80.7177C84.4606 82.7847 82.7847 84.4606 80.7177 84.4606H27.7667C12.4009 84.4606 0.293419 98.4522 3.52598 114.437C5.83699 125.865 16.522 134 28.5205 134H134V27.7667Z",
    className: "green"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.539 27.7667C190.539 12.4009 176.547 0.293419 160.561 3.52598C149.134 5.83699 141 16.522 141 28.5205V134H247.234C262.599 134 274.707 120.007 271.474 104.022C269.163 92.5947 258.478 84.4606 246.48 84.4606H194.281C192.214 84.4606 190.539 82.7847 190.539 80.7177V27.7667Z",
    className: "torquise"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141 248.233C141 263.599 154.993 275.707 170.978 272.474C182.405 270.163 190.539 259.478 190.539 247.48L190.539 195.282C190.539 193.215 192.215 191.539 194.282 191.539L247.233 191.539C262.599 191.539 274.707 177.548 271.474 161.563C269.163 150.135 258.478 142 246.48 142L141 142L141 248.233Z",
    className: "torquise"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4607 248.233C84.4607 263.599 98.4534 275.707 114.439 272.474C125.866 270.163 134 259.478 134 247.48L134 142L27.7664 142C12.4006 142 0.293419 155.993 3.526 171.978C5.83741 183.405 16.5217 191.539 28.5204 191.539L80.7186 191.539C82.7857 191.539 84.4607 193.215 84.4607 195.282L84.4607 248.233Z",
    className: "torquise"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9999 3C16.4314 3 3 16.4314 3 32.9999C3 49.5686 16.4314 63 32.9999 63C49.5686 63 63 49.5686 63 32.9999C63 16.4314 49.5686 3 32.9999 3Z",
    className: "green"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatusehat);
export default __webpack_public_path__ + "static/media/satusehat.22c18f53289e9a8bdbb515f16c39ad30.svg";
export { ForwardRef as ReactComponent };